import {
  getCountryCodes,
  currentLanguage,
  articleCountry,
  currentCountry,
  isGlobalSite,
  langCodeTA,
  langCode,
  initialSearchTab,
} from './currentLanguage';

export {
  getCountryCodes,
  currentLanguage,
  langCodeTA,
  langCode,
  currentCountry,
  articleCountry,
  isGlobalSite,
  initialSearchTab,
};



// WEBPACK FOOTER //
// ./src/utils/currentLanguage/index.js